// extracted by mini-css-extract-plugin
export default {"root":"_9obR_7","mobile":"wwK04K"};